import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import Logo from 'ui-component/Logo_Youteach';
import Arrow2 from './assets/dropdown-arrow.svg';
import Expand from './assets/expand.svg';
import Exit from './assets/exit.svg';
import Hamburger from './assets/hamburger.svg';
import Add from './assets/add.svg';
import UploadIcon from './assets/upload.svg';
import APIKeyModal from './preferences/APIKeyModal';
import {
    selectApiKeyStatus,
    selectSelectedDocs,
    selectSelectedDocsStatus,
    selectSourceDocs,
    setSelectedDocs,
    selectConversations,
    setConversations,
    selectConversationId
} from './preferences/preferenceSlice';
import { setConversation, updateConversationId } from './conversationSlice';
import { useMediaQuery, useOutsideAlerter } from 'hooks/useMediaQuery';
import Upload from './upload/Upload';
import SelectDocsModal from './preferences/SelectDocsModal';
import ConversationTile from './ConversationTile';
import { store } from 'store';
import apiSlice from 'store/slices/apiSlice';
// REMOVED: AWS SDK - migrated to Firebase Storage
// import AWS from 'aws-sdk';
// MIGRATED: AWS SDK removed, backend now uses Firebase Storage (GCS)

const project = 'mindmap';
export default function Navigation({ navOpen, setNavOpen, isLoading, setLoading }) {
    const dispatch = useDispatch();
    const docs = useSelector(selectSourceDocs);
    const selectedDocs = useSelector(selectSelectedDocs);
    const conversations = useSelector(selectConversations);
    const conversationId = useSelector(selectConversationId);
    const { isMobile } = useMediaQuery();

    const [isDocsListOpen, setIsDocsListOpen] = useState(false);

    const isApiKeySet = useSelector(selectApiKeyStatus);
    const [apiKeyModalState, setApiKeyModalState] = useState('INACTIVE');

    const isSelectedDocsSet = useSelector(selectSelectedDocsStatus);
    // const [selectedDocsModalState, setSelectedDocsModalState] = useState(
    //   isSelectedDocsSet ? "INACTIVE" : "ACTIVE"
    // )

    const [selectedDocsModalState, setSelectedDocsModalState] = useState('ACTIVE');

    const [uploadModalState, setUploadModalState] = useState('INACTIVE');

    const navRef = useRef(null);
    const embeddingsName = 'openai_text-embedding-ada-002';

    const S3_BUCKET = 'youteach.ai';
    const REGION = 'ap-southeast-1';

    // REMOVED: AWS configuration
    // AWS.config.update({
    //     accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    //     secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
    //     s3Url: 'http://kmou-dp.s3-website-ap-southeast-1.amazonaws.com',
    //     bucketName: S3_BUCKET,
    //     region: REGION
    //   });

    // Legacy stub - AWS SDK removed, migrated to Firebase Storage
    const s3 = {
        upload: (_, cb) => cb && cb(new Error('AWS S3 disabled')),
        deleteObject: (_, cb) => cb && cb(new Error('AWS S3 disabled')),
        deleteObjects: (_, cb) => cb && cb(new Error('AWS S3 disabled')),
        putObject: (_, cb) => cb && cb(new Error('AWS S3 disabled')),
        listObjects: (_, cb) => cb && cb(new Error('AWS S3 disabled'), { Contents: [] }),
        listObjectsV2: (_, cb) => cb && cb(new Error('AWS S3 disabled'), { Contents: [], CommonPrefixes: [] }),
        getObject: (_, cb) => cb && cb(new Error('AWS S3 disabled'), null),
        getSignedUrlPromise: () => Promise.reject(new Error('AWS S3 disabled'))
    };

    const navigate = useNavigate();

    useEffect(() => {
        fetchConversations();
    }, []);

    useEffect(() => {
        if (!conversations) {
            fetchConversations();
        }
    }, [conversations, dispatch]);

    async function fetchConversations() {
        try {
            const res = await store.dispatch(
                apiSlice.endpoints.getConversationsList.initiate({
                    project,
                    user_token: localStorage.getItem('user_token')
                })
            );
            if (res.data) dispatch(setConversations(res.data));
        } catch (error) {
            console.error('Failed to fetch conversations: ', error);
        }
    }

    const handleDeleteConversation = (id) => {
        store
            .dispatch(apiSlice.endpoints.deleteConversation.initiate(id))
            .then(() => fetchConversations())
            .catch((error) => console.error(error));
    };

    const handleDeleteClick = (index, doc) => {
        const docPath = 'indexes/' + 'local' + '/' + localStorage.getItem('user_token') + '/' + project + '/' + doc.name;

        store
            .dispatch(apiSlice.endpoints.getDeleteOld.initiate(docPath))
            .then(() => {
                // remove the image element from the DOM
                const imageElement = document.querySelector(`#img-${index}`);
                const parentElement = imageElement.parentNode;
                parentElement.parentNode?.removeChild(parentElement);

                let params = {
                    Bucket: 'youteach.ai',
                    Prefix: localStorage.getItem('user_token') + '/' + project + '/' + doc.name
                };

                s3.listObjects(params, function (err, data) {
                    if (err) return console.log(err);

                    if (data.Contents.length == 0) {
                        s3.deleteObjects(params, function (err, data) {
                            if (err) return console.log(err);
                            else {
                                console.log('Delete Success');
                            }
                        });
                    } else {
                        data.Contents.forEach(function (content) {
                            params = { Bucket: 'youteach.ai' };
                            params.Delete = { Objects: [] };
                            params.Delete.Objects.push({ Key: content.Key });
                        });

                        s3.deleteObjects(params, function (err, data) {
                            if (err) return console.log(err);
                            else {
                                console.log('Delete Success');
                            }
                        });
                    }
                });

                // const params = {
                //   Bucket: 'youteach.ai',
                //   Key: localStorage.getItem('user_token') + '/document/' + doc.name
                // };

                // s3.deleteObject(params, function(err, data) {
                //   if (err) console.log(err, err.stack); // an error occurred
                //   else     console.log("success");           // successful response
                // });
            })
            .catch((error) => console.error(error));
    };

    const handleConversationClick = (index) => {
        setLoading(true);
        store
            .dispatch(apiSlice.endpoints.getConversation.initiate(index))
            .then((res) => {
                if (!res.data) return;
                navigate('/workspace/' + project);
                dispatch(setConversation(res.data));
                dispatch(
                    updateConversationId({
                        query: { conversationId: index }
                    })
                );
            })
            .finally(() => setLoading(false));
    };

    async function updateConversationName(updatedConversation) {
        try {
            const res = await store.dispatch(
                apiSlice.endpoints.updateConversation.initiate({
                    id: updatedConversation.id,
                    ...updatedConversation
                })
            );
            if (res?.data) {
                navigate('/workspace/' + project);
                fetchConversations();
            }
        } catch (err) {
            console.error(err);
        }
    }
    useOutsideAlerter(navRef, () => {
        if (isMobile && navOpen && apiKeyModalState === 'INACTIVE') {
            setNavOpen(false);
            setIsDocsListOpen(false);
        }
    }, [navOpen, isDocsListOpen, apiKeyModalState]);

    /*
    Needed to fix bug where if mobile nav was closed and then window was resized to desktop, nav would still be closed but the button to open would be gone, as per #1 on issue #146
  */

    useEffect(() => {
        setNavOpen(!isMobile);
    }, [isMobile]);

    return (
        <>
            {!navOpen && (
                <button
                    className="duration-25 absolute sticky top-10 left-3 z-20 hidden transition-all md:block"
                    onClick={() => {
                        setNavOpen(!navOpen);
                    }}
                >
                    <img
                        src={Expand}
                        alt="menu toggle"
                        className={`${!navOpen ? 'rotate-180' : 'rotate-0'} m-auto transition-all duration-200`}
                    />
                </button>
            )}
            <div
                ref={navRef}
                style={{ marginTop: 120 }}
                className={`${
                    !navOpen && '-ml-96 md:-ml-[18rem]'
                } duration-20 fixed top-0 z-20 flex h-full w-72 flex-col border-r-2 bg-white transition-all`}
            >
                <div className={'visible mt-2 flex h-16 w-full justify-between md:h-12'}>
                    <div className="my-auto mx-0 flex cursor-pointer gap-1.5">
                        <Logo />
                    </div>
                    <button
                        className="float-right mr-5"
                        onClick={() => {
                            setNavOpen(!navOpen);
                        }}
                    >
                        <img
                            src={Expand}
                            alt="menu toggle"
                            className={`${!navOpen ? 'rotate-180' : 'rotate-0'} m-auto transition-all duration-200`}
                        />
                    </button>
                </div>
                <NavLink
                    to={'/workspace/' + project}
                    onClick={() => {
                        dispatch(setConversation([]));
                        dispatch(
                            updateConversationId({
                                query: { conversationId: null }
                            })
                        );
                    }}
                    className={({ isActive }) =>
                        `${
                            isActive ? 'bg-gray-3000' : ''
                        } group mx-4 mt-4 flex cursor-pointer gap-2.5 rounded-3xl border border-silver p-3 hover:border-rainy-gray hover:bg-gray-3000`
                    }
                >
                    <img src={Add} alt="new" className="opacity-80 group-hover:opacity-100" />
                    <p className="my-auto text-sm text-dove-gray group-hover:text-neutral-600">Tạo hội thoại mới</p>
                </NavLink>
                <p className="ml-6 mt-3 text-sm font-semibold">Tin nhắn</p>
                {conversations && (
                    // <div className="conversations-container mb-auto max-h-[25rem] overflow-y-auto">
                    <div>
                        {conversations?.map((conversation) => (
                            <ConversationTile
                                key={conversation.id}
                                conversation={conversation}
                                selectConversation={(id) => handleConversationClick(id)}
                                onDeleteConversation={(id) => handleDeleteConversation(id)}
                                onSave={(conversation) => updateConversationName(conversation)}
                            />
                        ))}
                    </div>
                )}

                <div className="flex flex-col-reverse border-b-2">
                    <div className="relative my-4 flex gap-2 px-2">
                        <div
                            className="flex h-12 w-5/6 cursor-pointer justify-between rounded-3xl border-2 bg-white"
                            onClick={() => setIsDocsListOpen(!isDocsListOpen)}
                        >
                            {selectedDocs && (
                                <p className="my-3 mx-4 overflow-hidden text-ellipsis whitespace-nowrap">
                                    {selectedDocs.name} {selectedDocs.version}
                                </p>
                            )}
                            <img
                                src={Arrow2}
                                alt="arrow"
                                className={`${!isDocsListOpen ? 'rotate-0' : 'rotate-180'} ml-auto mr-3 w-3 transition-all`}
                            />
                        </div>
                        <img
                            className="mt-2 h-9 w-9 hover:cursor-pointer"
                            src={UploadIcon}
                            onClick={() => setUploadModalState('ACTIVE')}
                        ></img>
                        {isDocsListOpen && (
                            <div className="absolute top-12 left-0 right-6 z-10 ml-2 mr-4 max-h-52 overflow-y-scroll bg-white shadow-lg">
                                {docs ? (
                                    docs.map((doc, index) => {
                                        if (doc.model === embeddingsName) {
                                            return (
                                                <div
                                                    key={index}
                                                    onClick={() => {
                                                        dispatch(setSelectedDocs(doc));
                                                        setIsDocsListOpen(false);
                                                    }}
                                                    className="flex h-10 w-full cursor-pointer items-center justify-between border-x-2 border-b-2 hover:bg-gray-100"
                                                >
                                                    <p className="ml-5 flex-1 overflow-hidden overflow-ellipsis whitespace-nowrap py-3">
                                                        {doc.name} {doc.version}
                                                    </p>
                                                    {doc.location === 'local' && (
                                                        <img
                                                            src={Exit}
                                                            alt="Exit"
                                                            className="mr-4 h-3 w-3 cursor-pointer hover:opacity-50"
                                                            id={`img-${index}`}
                                                            onClick={(event) => {
                                                                event.stopPropagation();
                                                                handleDeleteClick(index, doc);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            );
                                        }
                                    })
                                ) : (
                                    <div className="h-10 w-full cursor-pointer border-x-2 border-b-2 hover:bg-gray-100">
                                        <p className="ml-5 py-3">Chưa có tài liệu mặc định.</p>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <p className="ml-6 mt-3 text-sm font-semibold">Tài liệu nguồn</p>
                </div>

                {/* <div className="flex flex-col gap-2 border-b-2 py-2">
        <NavLink
          to="/settings"
          className={({ isActive }) =>
            `my-auto mx-4 flex h-9 cursor-pointer gap-4 rounded-3xl hover:bg-gray-100 ${
              isActive ? 'bg-gray-3000' : ''
            }`
          }
        >
          <img src={SettingGear} alt="info" className="ml-2 w-5 opacity-60" />
          <p className="my-auto text-eerie-black">Settings</p>
        </NavLink>
      </div> */}

                {/* <div className="flex flex-col gap-2 border-b-2 py-2">
        <NavLink
          to="/about"
          className={({ isActive }) =>
            `my-auto mx-4 flex h-9 cursor-pointer gap-4 rounded-3xl hover:bg-gray-100 ${
              isActive ? 'bg-gray-3000' : ''
            }`
          }
        >
          <img src={Info} alt="info" className="ml-2 w-5" />
          <p className="my-auto text-sm text-eerie-black">About</p>
        </NavLink>

        <a
          href="https://docs.docsgpt.co.uk/"
          target="_blank"
          rel="noreferrer"
          className="my-auto mx-4 flex h-9 cursor-pointer gap-4 rounded-3xl hover:bg-gray-100"
        >
          <img src={Documentation} alt="documentation" className="ml-2 w-5" />
          <p className="my-auto text-sm text-eerie-black">Documentation</p>
        </a>
        <a
          href="https://discord.gg/WHJdfbQDR4"
          target="_blank"
          rel="noreferrer"
          className="my-auto mx-4 flex h-9 cursor-pointer gap-4 rounded-3xl hover:bg-gray-100"
        >
          <img src={Discord} alt="link" className="ml-2 w-5" />
          <p className="my-auto text-sm text-eerie-black">
            Visit our Discord
          </p>
        </a>

        <a
          href="https://github.com/arc53/DocsGPT"
          target="_blank"
          rel="noreferrer"
          className="my-auto mx-4 flex h-9 cursor-pointer gap-4 rounded-3xl hover:bg-gray-100"
        >
          <img src={Github} alt="link" className="ml-2 w-5" />
          <p className="my-auto text-sm text-eerie-black">Visit our Github</p>
        </a>
      </div> */}
            </div>
            <div className="fixed z-10 h-16 w-full border-b-2 bg-gray-50 md:hidden">
                <button className="mt-5 ml-6 h-6 w-6 md:hidden" onClick={() => setNavOpen(true)}>
                    <img src={Hamburger} alt="menu toggle" className="w-7" />
                </button>
            </div>
            <SelectDocsModal
                modalState={selectedDocsModalState}
                setModalState={setSelectedDocsModalState}
                isCancellable={isSelectedDocsSet}
            />
            <APIKeyModal modalState={apiKeyModalState} setModalState={setApiKeyModalState} isCancellable={isApiKeySet} />
            <Upload modalState={uploadModalState} setModalState={setUploadModalState}></Upload>
        </>
    );
}
